module.exports = __webpack_public_path__ + "fa01a5696f0fb7a9c32c675e822b3010.png";